module.exports = __webpack_public_path__ + "static/media/avatar-large.597dd6de.png";